import React, { useState, useEffect } from 'react';
import api from '../../utils/api';

const Stat = ({ icon, label, value, color = 'text-primary-container' }) => (
  <div className="bg-white border border-outline-variant/20 p-6 flex items-center gap-5">
    <div className={`w-14 h-14 flex items-center justify-center bg-surface-container ${color}`}>
      <span className="material-symbols-outlined text-[28px]">{icon}</span>
    </div>
    <div>
      <p className="font-label text-[10px] uppercase tracking-widest text-secondary">{label}</p>
      <p className="font-headline font-black text-3xl text-on-surface">{value}</p>
    </div>
  </div>
);

export default function AdminDashboard() {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/dashboard')
      .then(r => setStats(r.data.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div>
      <h1 className="font-headline font-black text-3xl uppercase tracking-tight mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {[...Array(4)].map((_, i) => <div key={i} className="h-28 skeleton" />)}
      </div>
    </div>
  );

  return (
    <div>
      <div className="mb-8">
        <h1 className="font-headline font-black text-3xl uppercase tracking-tight">Dashboard</h1>
        <p className="font-body text-sm text-secondary mt-1">Welcome back. Here's an overview of your site.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <Stat icon="inventory_2"   label="Total Products"   value={stats?.totalProducts   || 0} />
        <Stat icon="receipt_long"  label="Total Inquiries"  value={stats?.totalInquiries  || 0} color="text-blue-600" />
        <Stat icon="schedule"      label="Pending"          value={stats?.pendingInquiries || 0} color="text-yellow-600" />
        <Stat icon="group"         label="Users"            value={stats?.totalUsers       || 0} color="text-green-600" />
      </div>

      {/* Recent inquiries */}
      {stats?.recentInquiries?.length > 0 && (
        <div className="bg-white border border-outline-variant/20">
          <div className="px-6 py-4 border-b border-surface-container flex items-center justify-between">
            <h2 className="font-headline font-bold text-lg uppercase tracking-tight">Recent Inquiries</h2>
            <a href="/admin/inquiries" className="font-label text-xs text-primary-container hover:underline uppercase tracking-wider">View All →</a>
          </div>
          <div className="overflow-x-auto">
            <table className="cf-table">
              <thead>
                <tr>
                  <th>Inquiry No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Items</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {stats.recentInquiries.map(inq => (
                  <tr key={inq._id}>
                    <td className="font-bold text-primary-container">{inq.inquiryNumber}</td>
                    <td>{inq.userName}</td>
                    <td className="text-secondary text-xs">{inq.userEmail}</td>
                    <td>{inq.items?.length || 0}</td>
                    <td>
                      <span className={`badge ${inq.status === 'pending' ? 'badge-orange' : inq.status === 'replied' ? 'badge-green' : 'badge-gray'}`}>
                        {inq.status}
                      </span>
                    </td>
                    <td className="text-secondary text-xs">{new Date(inq.createdAt).toLocaleDateString('en-IN')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Quick actions */}
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { href: '/admin/products',    icon: 'add_box',       label: 'Add Product'   },
          { href: '/admin/categories',  icon: 'add_circle',    label: 'Add Category'  },
          { href: '/admin/price-lists', icon: 'upload_file',   label: 'Upload PDF'    },
          { href: '/admin/content',     icon: 'edit_note',     label: 'Edit Content'  },
        ].map(({ href, icon, label }) => (
          <a key={href} href={href}
            className="bg-white border border-outline-variant/20 p-5 flex flex-col items-center gap-2 text-center hover:border-primary-container transition-colors group">
            <span className={`material-symbols-outlined text-[28px] text-secondary group-hover:text-primary-container transition-colors`}>{icon}</span>
            <span className="font-label text-xs font-bold uppercase tracking-wider text-on-surface">{label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
